import script from "./LeaderTeamRouter.vue?vue&type=script&setup=true&lang=js"
export * from "./LeaderTeamRouter.vue?vue&type=script&setup=true&lang=js"

import "./LeaderTeamRouter.vue?vue&type=style&index=0&id=4de77aca&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4de77aca"]])

export default __exports__